export const PrintableForms = [
  {
    name: 'Gyártás',
    url: 'production',
  },
  {
    name: '4D',
    url: 'complaintReport4D',
  },
  {
    name: '8D',
    url: 'complaintReport8D',
  },
  {
    name: 'Megfelelőségi nyilatkozat / Váradi',
    url: 'varadiMetal/conformity',
  },
  {
    name: 'Cikk címke',
    url: 'item',
  },
];
